import Vue from 'vue'
import App from './App.vue'
import i18n from './lang/lang'
import store from './store'
import vuetify from './plugins/vuetify';
import router from './router'
import Axios from 'axios'
import VueClipboard from 'vue-clipboard2'
import VueMeta from 'vue-meta'
import VueMobileDetection from 'vue-mobile-detection'
//import flutter from './plugins/flutter';
//import NotificationHub from './utils/notification-hub'

Vue.prototype.$http = Axios;
Vue.config.productionTip = false;

Vue.component("main-menu", () => import("./components/Menu"));
Vue.component("Footer", () => import("./components/Footer"));
Vue.component("select-country", () => import("./components/Select/SelectCountry"));
Vue.component("CommonContentArea", () => import("./components/CommonContentArea"));
Vue.component("SpotInquiry", () => import("./components/SpotInquiry"));
Vue.component("Language", () => import("./components/Language"));
Vue.component("Login", () => import("./components/Login"));
Vue.component("Register", () => import("./components/Register"));
Vue.component("MenuFab", () => import("./components/MenuFab"));
Vue.component("SnackbarMsg", () => import("./components/SnackbarMsg"));

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.use(VueMeta);
Vue.use(VueMobileDetection);
//Vue.use(flutter);
// if (process.env.NODE_ENV === "development"){
//   Vue.use(NotificationHub);
// }

export const app = new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');

window['vue'] = app
window.store = store

